import request from "_private/utils/request";

let PAGESIZE = 500;

// let mock = "/mock/5c7fb1b653377c002106962b";
let mock = "";

//--------------------------------------marker---------------------------------------//
// 获取marker数据
const fetchMarkerDatas_Api = function() {
  return new Promise((resolve, reject) => {
    fetchMarkers({
      params: { pageParamVO: { curPage: 1, pageSize: PAGESIZE } },
      resolve,
      reject,
      dataArr: []
    });
  });
};
const fetchMarkers = function(opts) {
  return request({
    url: `${mock}/monitorCenter/logistics/getCustomPointList`,
    method: "post",
    headers: { type: "json" },
    data: opts.params
  }).then(res => {
    if (res.code == 1 && res.result && Array.isArray(res.result.data)) {
      opts.dataArr = [...opts.dataArr, ...res.result.data];
      if (opts.dataArr.length < res.result.totalRecords) {
        // 数据未请求完，继续请求
        opts.params.curPage++;
        fetchMarkers(opts);
      } else {
        opts.resolve(opts.dataArr);
      }
    }
  });
};

// 保存marker
const saveMarker_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/saveCustomPoint`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};
//--------------------------------------area---------------------------------------//
// 获取area数据
const fetchAreaDatas_Api = function() {
  return new Promise((resolve, reject) => {
    fetchAreas({
      params: { pageParamVO: { curPage: 1, pageSize: PAGESIZE } },
      resolve,
      reject,
      dataArr: []
    });
  });
};
const fetchAreas = function(opts) {
  return request({
    url: `${mock}/monitorCenter/logistics/getCustomAreaList`,
    method: "post",
    headers: { type: "json" },
    data: opts.params
  }).then(res => {
    if (res.code == 1 && res.result && Array.isArray(res.result.data)) {
      opts.dataArr = [...opts.dataArr, ...res.result.data];
      if (opts.dataArr.length < res.result.totalRecords) {
        // 数据未请求完，继续请求
        opts.params.pageParamVO.curPage++;
        fetchAreas(opts);
      } else {
        opts.resolve(opts.dataArr);
      }
    }
  });
};

// 保存area
const saveArea_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/saveCustomArea`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};
//--------------------------------------line---------------------------------------//
// 获取line数据
const fetchLineDatas_Api = function() {
  return new Promise((resolve, reject) => {
    fetchLines({
      params: { pageParamVO: { curPage: 1, pageSize: PAGESIZE } },
      resolve,
      reject,
      dataArr: []
    });
  });
};
const fetchLines = function(opts) {
  return request({
    url: `${mock}/monitorCenter/logistics/getCustomLineList`,
    method: "post",
    headers: { type: "json" },
    data: opts.params
  }).then(res => {
    if (res.code == 1 && res.result && Array.isArray(res.result.data)) {
      opts.dataArr = [...opts.dataArr, ...res.result.data];
      if (opts.dataArr.length < res.result.totalRecords) {
        // 数据未请求完，继续请求
        opts.params.curPage++;
        fetchLines(opts);
      } else {
        opts.resolve(opts.dataArr);
      }
    }
  });
};

// 保存line
const saveLine_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/saveCustomLine`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};
//--------------------------------------设置相关---------------------------------------//
// 获取marker和area的设置信息
const fetchOverlaySetting_Api = function() {
  return request({
    url: `/monitorCenter/logistics/getMonitSetting`,
    method: "post",
    headers: { type: "json" },
    data: {}
  });
};
// 保存marker和area的显示/隐藏信息
const saveOverlayShow_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/saveMonitObjShowSetting`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};
// 保存marker和area的等级信息
const saveOverlayLevel_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/saveMonitLevelSetting`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};

//--------------------------------------智能搜索---------------------------------------//
const fetchIntelligentVehicles_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/getVehicleListByVehicleNo`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};

//--------------------------------------拉框查找---------------------------------------//
const fetchMyVehiclesByPullRect_Api = function(params) {
  return request({
    url: `${mock}/monitorCenter/logistics/getVehicleListByRect`,
    method: "post",
    headers: { type: "json" },
    data: params
  });
};
const exportPullRect_Api = function(data) {
  let exportUrl = "/monitorCenter/logistics/exportVehicleListByRect";
  if (data.vehicleIdList.length > 0) {
    exportUrl += "?vehicleIdList=" + data.vehicleIdList;
  }
  document.location.href = exportUrl;
};
//--------------------------------------类型---------------------------------------//
const fetchCategoryDatas_Api = function() {
  return request({
    url: `/monitorCenter/logistics/getDicAreaCategory`,
    method: "post",
    headers: { type: "json" }
  });
};

//--------------------------------------物流地图---------------------------------------//

export default {
  fetchMarkerDatas_Api,
  fetchAreaDatas_Api,
  fetchLineDatas_Api,
  saveMarker_Api,
  saveArea_Api,
  saveLine_Api,
  fetchOverlaySetting_Api,
  saveOverlayShow_Api,
  saveOverlayLevel_Api,
  fetchIntelligentVehicles_Api,
  fetchMyVehiclesByPullRect_Api,
  exportPullRect_Api,
  fetchCategoryDatas_Api
};
